import { useTown } from "@/hooks/use-town";
import { LocationControl } from "@/components/LocationPicker";

export function TownFilterBar() {
  const { locationLabel, openLocationPicker } = useTown();
  return <div className="border-t border-slate-100 px-4 py-2"><LocationControl label={locationLabel} onClick={() => openLocationPicker()} /></div>;
}
